import Size from "shared/util/Size";
import Backbone from "backbone";

interface WidgetCoords {
    x: number;
    y: number;
}

const calculateOriginalImageSceneRelativeSize = (model:Backbone.Model, experience:Backbone.Model): Size | null => {

    const crop = model.get("crop");
    if (crop) {
        const { width, height } = crop;
        const percentageWidth = model.get("width") / width;
        const percentageHeight = model.get("height") / height;

        const widthPercent = experience.get("width") / 100;
        const heightPercent = experience.get("height") / 100;

        return new Size(widthPercent * percentageWidth, heightPercent * percentageHeight);
    }

    return null;
};

const calculateWidgetCoords = (model:Backbone.Model, width: number, height: number): WidgetCoords => {
    const crop = model.get("crop");
    return {
        x: width * crop.x,
        y: height * crop.y
    };
};

export {
    calculateOriginalImageSceneRelativeSize,
    calculateWidgetCoords
};



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/imageWidget/helpers/ImageWidgetSizeCalculations.ts